import * as betprofessor from './ListItem.styles.betprofessor';
import * as betroyale from './ListItem.styles.betroyale';
import * as fiestabet from './ListItem.styles.fiestabet';
import * as goldenrush from './ListItem.styles.goldenrush';
import * as juicybet from './ListItem.styles.juicybet';
import * as puntcity from './ListItem.styles.puntcity';
import * as puntgenie from './ListItem.styles.puntgenie';
import * as questbet from './ListItem.styles.questbet';
import * as sterlingparker from './ListItem.styles.sterlingparker';
import * as vikingbet from './ListItem.styles.vikingbet';
import * as volcanobet from './ListItem.styles.volcanobet';
import * as forsport from './ListItem.styles.forsport';
import * as junglebet from './ListItem.styles.junglebet';
import * as betstride from './ListItem.styles.betstride';
import * as betgalaxy from './ListItem.styles.betgalaxy';
import * as wellbet from './ListItem.styles.wellbet';
import * as sugarcastle from './ListItem.styles.sugarcastle';
import * as oldgill from './ListItem.styles.oldgill';
import * as buffalobet from './ListItem.styles.buffalobet';
import * as titanbet from './ListItem.styles.titanbet';
import * as templebet from './ListItem.styles.templebet';
import * as bet777 from './ListItem.styles.bet777';
import * as goldenbet888 from './ListItem.styles.goldenbet888';
import * as gigabet from './ListItem.styles.gigabet';
import * as slambet from './ListItem.styles.slambet';
import * as hyperbet from './ListItem.styles.hyperbet';
import * as chromabet from './ListItem.styles.chromabet';
import * as bet575 from './ListItem.styles.bet575';
import * as epicodds from './ListItem.styles.epicodds';
import * as pyramidbet from './ListItem.styles.pyramidbet';
import * as magnumbet from './ListItem.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  betstride,
  betgalaxy,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  templebet,
  bet777,
  goldenbet888,
  gigabet,
  slambet,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
